import React, { useCallback, useEffect, useState } from 'react'
import BannerSlide, { BANNER_GROUP } from '../../../components/banner-slide/BannerSlide'
import { activityList, bannerSlideType, FrontApi, newsType } from '../../../api/front-api/front.api'
import { useDispatch, useSelector } from 'react-redux'
import { setLoading, unsetLoading } from '../../../store/loading/loading.slice'
import { Box, Divider, Typography } from '@mui/material'
import StateComponents from '../../../components/state-component/StateComponents'
import { icons } from '../../../assets/icons/icons'
import PaginationCustom from '../../../components/pagination/PaginationCustomTwo'
import { RootState } from '../../../store/store'
import clsx from 'clsx'
import { ContentCard, PopularBox } from './element/element'
import Hashids from 'hashids'
import { useNavigate } from 'react-router-dom'
import { routeName } from '../../../routes/routeName'
import { debouncedApiCall, shareToFacebook, shareToLine, shareToX } from '../../../utils/app.utils'
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import ActivityCalendar from '../../../components/calendar/ActivityCalendar'
import { likeContent, SOCIAL_MEDIA_TYPE } from '../../../utils/global.func'
import { htmlToPlainText } from '../../../components/render-html/func'
import { BANNER_TYPE } from '../../cms-website/website-structure/content/enum/content.enum'
import { useTranslation } from 'react-i18next'

type Props = {}

const Activity: React.FC<Props> = ({ }: Props) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const img_url = useSelector((state: RootState) => state.api.image_api);
    const navigate = useNavigate();
    const baseApi_content = useSelector((state: RootState) => state.api.public_content_api);


    const [search, setSearch] = useState<string>("");
    const [category, set_category] = useState<any[]>([]);
    const [banner_slide_data, set_banner_slide_data] = useState<any[]>([]);
    const [top_five_news, set_top_five_news] = useState<any[]>([]);
    const [data, setData] = useState<any[]>([]);
    const [page, setPage] = useState<number>(1);
    const [pageLimit, _setPageLimit] = useState<number>(6);
    const [totalItems, setTotalItems] = useState<number>(0);
    const [activity_category, set_activity_category] = useState<any[]>([]);
    const [id_activity_category, set_id_activity_category] = useState<number | null>(null);

    const hash_ids = new Hashids(process.env.REACT_APP_SECRET_SALT, 50);
    const encodeId = (id_content: number) => {
        const id = hash_ids.encode(id_content);
        navigate(routeName.main.activityDetail.replace(":id", id))
    }

    const handleGetCategory = async () => {
        await FrontApi.category({ limit: 100, page: 1 }).then((res) => {
            if (res.status < 300) {
                const response = res.data?.data?.data?.items;
                set_category(response)
            }
        }).catch((err) => console.log(err))
    }

    const handleActivityGetCategory = async () => {
        await FrontApi.activityCategoryDropdown().then((res) => {
            if (res.status < 300) {
                const response = res.data?.data || []
                set_activity_category(response);
                console.log(response, 'response')
            }
        }).catch((err) => {
            console.log(err)
        })
    }

    const handleGetTopFiveNews = async () => {
        let query: newsType = {
            page: 1,
            limit: 5,
            sortBy: "view_total"
        }
        await FrontApi.activity(query).then((res) => {
            if (res.status < 300) {
                const response = res.data?.data?.items || [];
                set_top_five_news(response)
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }
    const handleGetBannerSlideData = async () => {
        let query: bannerSlideType = {
            page: 1,
            limit: 10,
            banner_group: BANNER_GROUP.ACTIVITY
        }
        dispatch(setLoading());
        await FrontApi.banner(query).then((res) => {
            if (res.status < 300) {
                const response = res.data?.data?.items || [];
                set_banner_slide_data(response);
                // console.log(response, 'response')
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }


    const handleGetContents = useCallback(async () => {
        let query: activityList = {
            page: page,
            limit: pageLimit
        }
        if (id_activity_category) query.id_activity_category = id_activity_category;
        if (search) query.keyword = search
        dispatch(setLoading());
        await FrontApi.activity(query).then((res) => {
            if (res.status < 300) {
                const response = res.data?.data?.items || [];
                setTotalItems(res.data?.data?.meta?.totalItems)
                setData(response)
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }, [page, pageLimit, id_activity_category, search])

    useEffect(() => {
        handleGetCategory();
        handleGetTopFiveNews();
        handleGetBannerSlideData();
        handleActivityGetCategory();
    }, [])
    useEffect(() => {
        handleGetContents();
    }, [handleGetContents])
    return (
        // <div>
        // </div>
        <>
            <BannerSlide banner_type={BANNER_TYPE.TYPE_ONE} banner_slide={banner_slide_data} />
            <Box className="w-full py-10 m-auto sm:max-w-[1440px] md:max-w-[1920px] min-h-screen px-4">
                <Box className="grid grid-cols-12 gap-8">
                    <Box className="flex flex-col gap-4 col-span-12 xl:col-span-5">
                        <StateComponents
                            typeProps={[
                                {
                                    seq: 1,
                                    type: "TEXT_FIELD",
                                    gridProps: {
                                        xs: 12
                                    },
                                    fieldProps: {
                                        startAdornment: <Box px={2}><icons.SearchNormal /></Box>,
                                        placeholder: t('ค้นหา'),
                                        onChange: (e) => debouncedApiCall({ searchItem: e.target.value, setItem: setSearch }),
                                    }
                                }
                            ]}
                        />
                        <Box data-aos="zoom-in-right" className="flex flex-col gap-4 shadow-md rounded-xl p-6">
                            <Box component={"section"}>
                                <Typography sx={{ color: "#4A4A4A" }} fontWeight={600} fontSize={24}>
                                    {t("หมวดหมู่กิจกรรม")}
                                </Typography>
                                <Box onClick={() => set_id_activity_category(null)} className={clsx('cursor-pointer hover:text-[#bea57f]', {
                                    'text-[#9E640E] !important': null === id_activity_category
                                })} >
                                    <Typography variant='h6' className="py-5">
                                        {t("ทุกหมวดหมู่กิจกรรม")}
                                    </Typography>
                                    <Divider />
                                </Box>
                                {activity_category?.map((list, i) => {
                                    return (
                                        <Box onClick={() => set_id_activity_category(list?.id_activity_category)} className={clsx('cursor-pointer hover:text-[#bea57f]', {
                                            'text-[#9E640E]': list?.id_activity_category === id_activity_category
                                        })} key={list?.id_activity_category}>
                                            <Typography variant='h6' className="py-5">
                                                {list?.activity_category_name || "-"}
                                            </Typography>
                                            {i !== activity_category.length - 1 && (
                                                <Divider />
                                            )}
                                        </Box>
                                    )
                                })}
                            </Box>
                        </Box>
                        <Box data-aos="zoom-in-right" className="flex flex-col gap-4 shadow-md rounded-xl p-6">
                            <Typography sx={{ color: "#4A4A4A" }} fontSize={{ xs: "20px", xl: "24px" }} fontWeight={700}>
                                {t("5 อันดับกิจกรรมที่มียอดเข้าชมมากที่สุด")}
                            </Typography>

                            <PopularBox data={top_five_news?.map((list) => {
                                return {
                                    end_date: list?.form_poll_end,
                                    group_name: list?.activity_category_name,
                                    start_date: list?.form_poll_start,
                                    title: list?.content_name || "-",
                                    total_vote: list?.count
                                }
                            })} />
                        </Box>
                        <Box data-aos="zoom-in-right" className="flex flex-col gap-4 shadow-md rounded-xl p-10">
                            <Box className="flex justify-center items-center gap-2">
                                <CalendarMonthIcon sx={{ fontSize: "30px" }} />
                                <Typography textAlign={"center"} fontWeight={600} fontSize={"32px"}>
                                    {t("ปฏิทินกิจกรรม")}
                                </Typography>
                            </Box>
                            <ActivityCalendar
                                data={data?.map((list) => {
                                    return {
                                        startDate: list?.activity_start_date,
                                        tfMobileRows: 0
                                    }
                                })}
                                pagination={{
                                    limit: 10,
                                    page: 1,
                                    total_item: 0,
                                    set_page: () => { },
                                    set_page_limit: () => { },
                                }}
                                activity_data={[]
                                }
                            />
                        </Box>
                    </Box>
                    <Box className="col-span-12 xl:col-span-7">
                        <ContentCard onChange={(id_content) => {
                            encodeId(id_content);
                        }}
                            data={data?.map((list) => {
                                const url_img = `${img_url}/${list?.media_file_path}/${list?.media_file_name}`;
                                const id = hash_ids.encode(list?.id_content);
                                const content_path_recommend = `${baseApi_content}/${routeName.main.activityDetail.replace(":id", id)}`;
                                const detail_text = htmlToPlainText(list?.content_detail);

                                return {
                                    id_key: list?.id_content,
                                    content_status_name: list?.content_status_name,
                                    detail: detail_text,
                                    group_name: list?.activity_category_name || "-",
                                    img_url: url_img,
                                    title: list?.content_name || "-",
                                    alt: list?.content_name,
                                    date: list?.activity_start_date,
                                    shared: +list?.total_shared ? +list?.total_shared : 0,
                                    view: list?.view_total ? list?.view_total : 0,
                                    like: list?.total_like ? +list?.total_like : 0,
                                    like_checked: list?.is_like ? true : false,
                                    onLike: () => likeContent(list?.id_content, !!list?.is_like ? 'DISLIKE' : 'LIKE', 'CONTENT', (st, id) => {
                                        setData(prev => prev.map((sp) => {
                                            return sp?.id_content === id ? {
                                                ...sp,
                                                is_like: !list?.is_like,
                                                total_like: !list?.is_like ? +sp?.total_like + 1 : +sp?.total_like - 1
                                            } : sp
                                        }))
                                    }),
                                    onShared: {
                                        facebookClick: () => {
                                            likeContent(list?.id_content, 'SHARED', 'CONTENT', (st, id) => {
                                                setData(prev => prev.map((sp) => {
                                                    return sp?.id_content === id ? {
                                                        ...sp,
                                                        total_shared: st ? +sp?.total_shared + 1 : +sp?.total_shared
                                                    } : sp
                                                }))
                                            }, SOCIAL_MEDIA_TYPE.FACEBOOK)
                                            shareToFacebook(content_path_recommend)
                                        },
                                        lineClick: () => {
                                            likeContent(list?.id_content, 'SHARED', 'CONTENT', (st, id) => {
                                                setData(prev => prev.map((sp) => {
                                                    return sp?.id_content === id ? {
                                                        ...sp,
                                                        total_shared: st ? +sp?.total_shared + 1 : +sp?.total_shared
                                                    } : sp
                                                }))
                                            }, SOCIAL_MEDIA_TYPE.LINE)
                                            shareToLine(content_path_recommend, list?.content_name);
                                        },
                                        xClick: () => {
                                            likeContent(list?.id_content, 'SHARED', 'CONTENT', (st, id) => {
                                                setData(prev => prev.map((sp) => {
                                                    return sp?.id_content === id ? {
                                                        ...sp,
                                                        total_shared: st ? +sp?.total_shared + 1 : +sp?.total_shared
                                                    } : sp
                                                }))
                                            }, SOCIAL_MEDIA_TYPE.X)
                                            shareToX(content_path_recommend, list?.content_name)
                                        },
                                    }
                                }
                            })}
                        />

                        {data?.length > 0 ? (
                            <PaginationCustom
                                page={page}
                                pageLimit={pageLimit}
                                setPage={(np) => setPage(np)}
                                totalItems={totalItems}
                            />
                        ) : (
                            <Typography>
                                {t("ไม่มีข้อมูล")}
                            </Typography>
                        )}
                    </Box>
                </Box>
            </Box>
        </>
    )
}

export default Activity